import { useEffect, useRef } from 'react';

interface InfoSliderProps {
	children: React.ReactNode;
	onClose: () => void;
}

export function InfoSlider(props: Readonly<InfoSliderProps>) {
	const { children, onClose } = props;
	const sliderRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function close(e: MouseEvent) {
			if (sliderRef.current && !sliderRef.current.contains(e.target as Node)) {
				onClose();
			}
		}

		// Delay adding the listener to skip the initial click
		const timeoutId = setTimeout(() => {
			document.addEventListener('click', close);
		}, 0);

		return () => {
			clearTimeout(timeoutId);
			document.removeEventListener('click', close);
		};
	}, [onClose]);

	return (
		<div
			ref={sliderRef}
			onClick={(e) => e.stopPropagation()}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.stopPropagation();
				}
			}}
		>
			{children}
		</div>
	);
}
